<template>
  <div style="overflow: auto !important;" class="am-landing">
    <am-toolbar
      class="am-landing__toolbar"
      :active.sync="menu"
      @brand="onBrandClick"
      @contact="onContactClick"
    />

    <transition name="navigation">
      <div class="am-landing__navigation" v-if="menu">
        <div class="am-landing__container">
          <am-list-external class="am-landing__menu" :items="navigation" @input="onMenuChange" />
        </div>
      </div>
    </transition>

    <!-- posts apenas devem ser carregando, dps da resposta do axios -->
    <am-post
      v-if="post.init && post.posts_ready"
      class="am-landing__view"
      :post="post"
      @gallery="onGalleryOpen"
      @submit="$store.commit('contact/submit', $event)"
      @click.native="menu = false; footer = false"
    />

    <transition name="full-gallery">
      <am-full-gallery
        class="am-landing__full-gallery"
        v-if="gallery"
        :current="image"
        :images="images"
        @close="$store.commit('gallery/close')"
      />
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AMToolbar from "@/components/molecules/AMToolbarExternal";
import AMDown from "@/components/molecules/AMDown";
import AMListExternal from "@/components/molecules/AMListExternal";
import AMFullGallery from "@/components/organisms/AMFullGallery";
import AMFooter from "@/components/organisms/AMFooter";
import AMPost from "@/components/templates/AMPost";

import axios from 'axios';

export default {
  components: {
    "am-toolbar": AMToolbar,
    "am-down": AMDown,
    "am-list-external": AMListExternal,
    "am-full-gallery": AMFullGallery,
    "am-footer": AMFooter,
    "am-post": AMPost
  },

  computed: {
    ...mapGetters({
      viewport: "viewport/getCurrent",
      navigation: "navigation/getItems",
      section: "navigation/getCurrent",
      anchors: "navigation/getAnchors",
      gallery: "gallery/getActive",
      image: "gallery/getCurrent",
      images: "gallery/getImages"
    }),

    menu: {
      get() {
        return this.$store.state.navigation.active;
      },
      set(value) {
        this.$store.commit("navigation/setActive", value);
      }
    }
  },
  data: () => ({
    footer: false,
    // Post
    post: {
      init: false,
      posts_ready: false,
      current: {

        title: "Entenda o que é Arquitetura Moderna e quais são suas influências",
        text:
          "A influência da Arquitetura Moderna se estende a diversas áreas, incluindo a arte e o design, e perdura até hoje em cidades do mundo inteiro. Assimilar o seu conceito é importante para compreender diversas características arquitetônicas, sejam elas contemporâneas, de décadas passadas e, possivelmente, até futuras. Neste post, você vai descobrir aspectos relevantes da Arquitetura Moderna e conhecer alguns dos principais nomes influenciados por essa vertente que mudou a forma com que as construções integram os ambientes. Confira! Qual é a diferença entre Moderno e Contemporâneo? No dia a dia, é comum confundir o significado de “moderno” e “contemporâneo”. Provavelmente você já viu esse primeiro termo sendo usado para se referir a algo atual. Está incorreto? Sim e não! Vamos explicar. O engano acontece porque há uma associação da palavra “moderno” com tudo aquilo que é novo ou diferente. No entanto, oficialmente, “moderno” remete aos ideais que surgiram na Europa e se alastraram pelo mundo no período entre 1453, com a tomada de Constantinopla pelos turcos otomanos, até 1789, com o início da Revolução Francesa. Já o período que sucede à Revolução Francesa, ou seja, dos anos 1789 até os dias atuais, é conhecido por Idade Contemporânea. Então por que não é equivocado se referir a algo recente como “moderno”? Porque as influências do modernismo continuam muito fortes e se desdobram até hoje em muitos aspectos da nossa vida. Além disso, abrange todas as áreas do conhecimento humano: as artes, a ciência e até o modo como a História é interpretada.",
        img: require("@/assets/images/hero/image.jpg"),
        category: {
          id:	'1',
          name:	"Cimento branco",
          created_at:	"2020-04-01 21:01:22",
          updated_at:	"2020-04-01 21:01:22"
        },
        category_id: '1',
        slug: "my_slug"
      },
      background: require("@/assets/images/hero/background.jpg"),
			posts: [
				{
					id: 1, 
					title: "Entenda o que é a Arquitetura Moderna e quais são suas influências 1", 
					slug: "slug",
          category: {
            id:	'1',
            name:	"Cimento branco",
            created_at:	"2020-04-01 21:01:22",
            updated_at:	"2020-04-01 21:01:22"
          },
          category_id: '0',
					img: require('@/assets/images/hero/image.jpg'),
					text: "text",
					created_at: "created_at"
				},
			],
    }
  }),
  mounted(){
    axios
		.get(process.env.API + '/api/' + this.$route.params.slug + '/post')
		.then(response => {
      this.post.current = response.data.data;
      this.post.current.img = process.env.API + '/storage/posts/' + this.post.current.img;
      
      this.post.init = true;

    })
    axios
    .get(process.env.API + '/api/posts')
    .then(r => {
      this.post.posts = r.data.data;
      this.post.posts.forEach(el => {
        el.img = process.env.API + '/storage/posts/' + el.img;
      });

      /* console.log("posts recuperados");
      console.log(r); */
      this.post.posts_ready = true;

      console.log("post init");
      console.log(this.post.init);
    })
    

  },
  methods: {
    onBrandClick() {
      this.menu = false;
      this.$store.commit("navigation/setCurrent", "hero");
    },

    onMenuChange(value) {
      if (this.viewport == "smartphone") {
        setTimeout(() => (this.menu = false), 300);
        setTimeout(
          () => this.$store.commit("navigation/setCurrent", value),
          500
        );
      } else {
        this.menu = false;
        this.$store.commit("navigation/setCurrent", value);
      }
    },

    onDownClick() {
      if (this.section == "contact") this.footer = !this.footer;
      else this.$store.commit("navigation/next");
    },

    onGalleryOpen(payload) {
      this.$store.commit("gallery/open", payload);
    },

    onContactClick() {
      this.$store.commit("navigation/setCurrent", "contact");
    }
  }
};
</script>

<style lang="scss">
body,
html {
  height: 100%;
}

.am-landing {
  display: flex;
  flex-flow: column;
  position: relative;

  &__toolbar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 40;
  }
  &__navigation {
    position: fixed;
    width: 100%;
    top: 60px;
    left: 0;
    bottom: 0;
    background: white;
    padding: 0 24px;
    box-sizing: border-box;
    z-index: 30;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.04);
  }
  &__container,
  &__menu {
    height: 100%;
  }
  &__full-gallery {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
  }
  &__below {
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    transform: translateY(100%);
    transition: 0.3s $easeInOutQuad;
    display: none;
    &.is-active {
      transform: translateY(0%);
    }
  }
  &__down {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 50;
  }
  &__footer {
    width: 100%;
  }

  @include grid-media($smartphone-grid) {
    .am-landing {
      //
    }
  }

  @include grid-media($desktop-grid) {
    &__navigation {
      height: auto;
      bottom: inherit;
      padding: 24px;
    }
    &__container {
      @include outer-container;
    }
    &__menu {
      @include grid-column(12);
    }
    &__below {
      display: flex;
    }
    .am-landing {
      //
    }
  }
}
</style>


